import { render } from "./grecaptcha.vue?vue&type=template&id=5219acfd&scoped=true"
import script from "./grecaptcha.vue?vue&type=script&lang=js"
export * from "./grecaptcha.vue?vue&type=script&lang=js"

import "./grecaptcha.vue?vue&type=style&index=0&id=5219acfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5219acfd"]])

export default __exports__